import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import SlickCarousel from 'slick-carousel';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    $(function () {
      $('.c-slider-work__main').slick({
        infinite: true,
        slidesToShow: 1,
        variableWidth: false,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        asNavFor: '.c-slider-work__sub',
        autoplaySpeed: 2500,
      });
      $('.c-slider-work__sub').slick({
        accessibility: true,
        arrows: false,
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.c-slider-work__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
            centerMode: true,
          }
        }]
      });

      $('.l-header__menu li').hover(function () {
        $(this).children('.l-header__submenu').addClass('is-active');
      }, function () {
        $(this).children('.l-header__submenu').removeClass('is-active');
      });


      /**************************
       * footer click menu
       **************************/
      function footerClick() {
        var win = $(window).innerWidth();
        if (win > 1001) {
          return false;
        }
        $('.c-footer-menu__title.is-parent').on('click', function () {
          return false;
        });
        $('.c-footer-menu__title.is-parent').on('click', function () {
          $(this).toggleClass('is-open');
          $(this).parent().toggleClass('is-open');
          $(this).next(".c-footer-menu__list").slideToggle();
        });
      }

      footerClick();


      /**************************
       * メインヴィジュアル
       **************************/
      function mainVisual() {
        var $win = $(window);
        $win.on('load', function () {
          var classname = 'is-active';
          var $text_wrap = $('.c-main-visual__opening');
          var $text_small = $('.c-main-visual__opening__text > small');
          var $text_large = $('.c-main-visual__opening__text > strong');

          //小さいテキストにクラスを渡し、大きいテキストにclass渡す処理
          setTimeout(function () {
            $text_small.addClass(classname, textLargeAddClass());
          }, 600);

          //大きいテキストにclass渡す関数
          function textLargeAddClass() {
            setTimeout(function () {
              $text_large.addClass(classname, mainVisualFadeout());
            }, 700);
          }

          //全体フェードアウト
          function mainVisualFadeout() {
            setTimeout(function () {
              $text_wrap.addClass(classname);
            }, 3700);
          }

          //owlcarousel　起動
          var owlMainvisual = $('.c-main-visual__slider');
          owlMainvisual.owlCarousel({
            items: 1,
            margin: 0,
            dots: true,
            loop: true,
            nav: false,
            autoWidth: false,
            autoplayHoverPause: true,
            autoplay: true,
            center: true,
            autoplaySpeed: 2000,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
          });
        });
      }

      mainVisual();
    });
  }
}

window.GApp = new App();
